<template>
  <div class="crew-basic-info-card">
    <div class="crew-basic-info-row">
      <div style="width: 70px;">辞令職</div>
      <div>{{ appointmentRoleName }}</div>
    </div>
    <div class="crew-basic-info-row">
      <div style="width: 70px;">社員区分</div>
      <div>{{ crew.employment_status || "-" }}</div>
    </div>
    <div class="crew-basic-info-row">
      <div style="width: 70px;">所属会社</div>
      <div>{{ crew.affiliated_company || "-" }}</div>
    </div>
  </div>
</template>
<script>
import {
  EnterpriseCrewRoleService,
  EnterpriseCrewsService,
} from "../../../services/master";
export default {
  props: {
    crew: { type: Object, required: true },
  },
  computed: {
    appointmentRoleName() {
      const appontmentRole = EnterpriseCrewsService.findAppointmentRoleFirst(
        this.crew
      );
      if (!appontmentRole) {
        return "-";
      }

      const appointmentRoleDetail = EnterpriseCrewRoleService.findById(
        appontmentRole.enterprise_crew_role_id
      );
      if (!appointmentRoleDetail) {
        return "-";
      }

      return appointmentRoleDetail.name;
    },
  },
};
</script>
<style scoped>
.crew-basic-info-card {
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.crew-basic-info-row {
  display: flex;
  height: 32px;
  gap: 16px;
  font-size: 12px;
  font-weight: bold;
}
</style>
